import {
  Box,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
  Image,
  HStack,
  Badge,
  VStack,
  Card,
  CardBody,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Center,
  Spinner,
  Flex,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  Switch,
  Progress,
  Avatar,
  Checkbox,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Divider,
} from "@chakra-ui/react";
import { MdVisibility, MdEdit, MdDelete, MdSearch, MdMoreVert, MdStar, MdChevronLeft, MdChevronRight, MdPerson, MdChatBubble, MdArrowUpward, MdGridView, MdList, MdCalendarToday, MdPhone, MdEmail } from "react-icons/md";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ImageWithFallback } from "components/ImageWithFallback";
import { BASE_URL } from "config/api";
import LoadingSpinner from "components/LoadingSpinner";
import starIcon from "assets/img/icons/Avis/star.png";
import starEmptyIcon from "assets/img/icons/Avis/star-empty.png";
import AvisDetailModal from "./AvisDetailModal";
import TraitementReclamationModal from "./TraitementReclamationModal";
import { usePermissions } from "hooks/usePermissions";
import { useNavbarAction } from "contexts/NavbarActionContext";

const RatingBadge = ({ rating }) => {
  const stars = [1, 2, 3, 4, 5];
  const numRating = parseFloat(rating) || 0;

  return (
    <HStack
      spacing={1.5}
      bg="#FFF9E7"
      border="1px solid"
      borderColor="#FFE899"
      px={2.5}
      py={0.5}
      borderRadius="full"
      w="fit-content"
      align="center"
    >
      <Text fontSize="13px" fontWeight="bold" color="#8D6E00" mr={0.5}>
        {numRating}
      </Text>
      <HStack spacing={0.5}>
        {stars.map((s) => (
          <svg key={s} width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            {numRating >= s ? (
              <path d="M8.81854 0.847599L10.1815 3.24022C10.2318 3.33329 10.3015 3.4145 10.3858 3.47839C10.4702 3.54227 10.5672 3.58735 10.6704 3.6106L13.2927 4.2106C13.5944 4.28717 13.8714 4.43975 14.0975 4.6538C14.3235 4.86785 14.4909 5.13622 14.5837 5.43333C14.6766 5.73044 14.6918 6.04638 14.6278 6.35102C14.5639 6.65567 14.423 6.93886 14.2186 7.1736L12.4408 9.2477C12.3711 9.33005 12.3187 9.42566 12.2869 9.52878C12.2551 9.63189 12.2444 9.74038 12.2556 9.84771L12.5223 12.6107C12.5606 12.9176 12.5172 13.2292 12.3963 13.514C12.2755 13.7987 12.0816 14.0465 11.8343 14.2322C11.5869 14.4179 11.2949 14.5349 10.9877 14.5715C10.6806 14.608 10.3693 14.5628 10.0852 14.4404L7.62593 13.3292C7.53043 13.2863 7.42692 13.2641 7.32222 13.2641C7.21752 13.2641 7.11401 13.2863 7.01851 13.3292L4.55922 14.4404C4.27657 14.5558 3.9687 14.5955 3.666 14.5556C3.3633 14.5157 3.07624 14.3976 2.83315 14.2128C2.59007 14.0281 2.39937 13.7832 2.27988 13.5022C2.16039 13.2212 2.11624 12.9139 2.15179 12.6107L2.41105 9.84771C2.42225 9.74038 2.41161 9.63189 2.37979 9.52878C2.34796 9.42566 2.2956 9.33005 2.22586 9.2477L0.448063 7.1736C0.243633 6.93886 0.102743 6.65567 0.0388279 6.35102C-0.0250876 6.04638 -0.00989785 5.73044 0.0829488 5.43333C0.175795 5.13622 0.343203 4.86785 0.56921 4.6538C0.795216 4.43975 1.07229 4.28717 1.374 4.2106L3.99625 3.6106C4.09947 3.58735 4.19651 3.54227 4.28084 3.47839C4.36517 3.4145 4.43483 3.33329 4.48515 3.24022L5.85554 0.847599C6.00726 0.589516 6.22377 0.375544 6.48362 0.226875C6.74348 0.0782069 7.03766 0 7.33704 0C7.63641 0 7.9306 0.0782069 8.19045 0.226875C8.4503 0.375544 8.66681 0.589516 8.81854 0.847599Z" fill="#F6B100" />
            ) : (
              <path d="M4.00986 14.3333C3.57452 14.3329 3.15124 14.1903 2.80441 13.9273C2.51217 13.7031 2.28181 13.4083 2.13501 13.0706C1.98821 12.7329 1.92979 12.3634 1.96526 11.9969L2.20502 9.47407C2.20778 9.44162 2.20388 9.40894 2.19358 9.37804C2.18327 9.34714 2.16677 9.31866 2.14508 9.29435L0.50674 7.4039C0.270128 7.12092 0.109328 6.7825 0.0394321 6.42039C-0.0304638 6.05828 -0.00716422 5.68436 0.107144 5.33372C0.213676 4.98438 0.409927 4.66904 0.676345 4.41911C0.942764 4.16918 1.27005 3.99338 1.62561 3.90922L4.00986 3.37004C4.0704 3.35053 4.12222 3.31051 4.15638 3.25688L5.39513 1.07355C5.56403 0.749849 5.81847 0.478622 6.13081 0.289349C6.44314 0.100076 6.80141 0 7.16667 0C7.53192 0 7.89019 0.100076 8.20253 0.289349C8.51486 0.478622 8.76931 0.749849 8.93821 1.07355L10.177 3.25688C10.2111 3.31051 10.2629 3.35053 10.3235 3.37004L12.7077 3.90922C13.0633 3.99338 13.3906 4.16918 13.657 4.41911C13.9234 4.66904 14.1197 4.98438 14.2262 5.33372C14.3405 5.68436 14.3638 6.05828 14.2939 6.42039C14.224 6.7825 14.0632 7.12092 13.8266 7.4039L12.2082 9.29435C12.1865 9.31866 12.17 9.34714 12.1597 9.37804C12.1494 9.40894 12.1455 9.44162 12.1483 9.47407L12.3881 11.9969C12.4235 12.3634 12.3651 12.7329 12.2183 13.0706C12.0715 13.4083 11.8411 13.7031 11.5489 13.9273C11.2621 14.1443 10.9219 14.2799 10.5644 14.3197C10.2069 14.3595 9.84523 14.3022 9.51762 14.1536L7.25991 13.1684C7.23061 13.1552 7.19882 13.1484 7.16667 13.1484C7.13451 13.1484 7.10273 13.1552 7.07343 13.1684L4.83569 14.1536C4.57639 14.2717 4.29481 14.333 4.00986 14.3333ZM7.16667 0.980354C6.96771 0.981758 6.77273 1.03616 6.60182 1.13795C6.4309 1.23975 6.29024 1.38525 6.19432 1.55947L4.95557 3.74281C4.87809 3.8836 4.77149 4.00628 4.64288 4.10269C4.51426 4.1991 4.36658 4.26703 4.20966 4.30196L1.83873 4.84779C1.64071 4.88961 1.45764 4.98402 1.30879 5.12108C1.15994 5.25814 1.05082 5.43278 0.992915 5.62661C0.930458 5.81989 0.918476 6.02593 0.958107 6.22515C0.997739 6.42438 1.08767 6.61016 1.21935 6.76487L2.84437 8.65532C3.05551 8.91016 3.15831 9.23755 3.13075 9.56727L2.89099 12.0901C2.86678 12.2943 2.89646 12.5013 2.97708 12.6904C3.0577 12.8796 3.18644 13.0444 3.35053 13.1684C3.50694 13.2885 3.69311 13.3637 3.88907 13.386C4.08502 13.4083 4.28334 13.3768 4.46274 13.2949L6.70713 12.2831C6.85136 12.2172 7.00809 12.1831 7.16667 12.1831C7.32525 12.1831 7.48197 12.2172 7.6262 12.2831L9.8706 13.2949C10.05 13.3768 10.2483 13.4083 10.4443 13.386C10.6402 13.3637 10.8264 13.2885 10.9828 13.1684C11.1438 13.0462 11.2706 12.8847 11.3511 12.6993C11.4315 12.514 11.463 12.311 11.4423 12.1101L11.2026 9.58724C11.175 9.25752 11.2778 8.93013 11.489 8.67529L13.114 6.78484C13.2457 6.63013 13.3356 6.44434 13.3752 6.24512C13.4149 6.0459 13.4029 5.83986 13.3404 5.64657C13.2856 5.44905 13.1779 5.27023 13.0288 5.12946C12.8797 4.98868 12.695 4.89128 12.4946 4.84779L10.1037 4.30196C9.94677 4.26703 9.79909 4.1991 9.67048 4.10269C9.54186 4.00628 9.43527 3.8836 9.35778 3.74281L8.13902 1.55947C8.04309 1.38525 7.90243 1.23975 7.73151 1.13795C7.5606 1.03616 7.36562 0.981758 7.16667 0.980354Z" fill="#656C7A" fill-opacity="0.2" />
            )}
          </svg>
        ))}
      </HStack>
    </HStack>
  );
};

const StatusBadge = ({ status }) => {
  const statusConfig = {
    visible: {
      bg: "#EDF7F1",
      border: "#CDE8D9",
      text: "#006133",
      label: "Visible"
    },
    hidden: {
      bg: "#FDF2F2",
      border: "#FBD5D5",
      text: "#9B1C1C",
      label: "Masqué"
    },
    pending: {
      bg: "#FFF9E7",
      border: "#FFE899",
      text: "#8D6E00",
      label: "En attente"
    }
  };

  const config = statusConfig[status] || statusConfig.visible;

  return (
    <HStack
      spacing={2}
      bg={config.bg}
      border="1px solid"
      borderColor={config.border}
      px={3}
      py={1}
      borderRadius="full"
      w="fit-content"
      align="center"
    >
      <Box w="8px" h="8px" borderRadius="full" bg={config.text} />
      <Text fontSize="13px" fontWeight="600" color={config.text}>
        {config.label}
      </Text>
    </HStack>
  );
};

export default function AvisSettings() {
  const { navbarHeight, showStats, setShowStats } = useNavbarAction();
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewData, setViewData] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('latest');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [viewMode, setViewMode] = useState('list'); // 'list' ou 'grid'
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isReclamationOpen,
    onOpen: onReclamationOpen,
    onClose: onReclamationClose
  } = useDisclosure();
  const toast = useToast();
  const [missionData, setMissionData] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const [ambulancierData, setAmbulancierData] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [nurseData, setNurseData] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const { hasPermission, loading: permissionsLoading } = usePermissions();

  useEffect(() => {
    if (permissionsLoading) return;

    if (!hasPermission('avis_read')) {
      return;
    }

    const fetchAvis = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${BASE_URL}/avis`, {
          withCredentials: true
        });
        setTableData(res.data);
        setLoading(false);
      } catch (err) {
        toast({ title: "Erreur lors du chargement des avis", status: "error", isClosable: true });
        setLoading(false);
      }
    };
    fetchAvis();
  }, [permissionsLoading, hasPermission]);

  const handleView = (avis) => {
    setViewData(avis);
    setPatientData(avis.patient || null);
    setMissionData(avis.mission || null);
    setAmbulancierData(avis.mission?.ambulancier || null);
    setDoctorData(avis.mission?.doctor || null);
    setNurseData(avis.mission?.nurse || null);
    onOpen();
  };

  const handleReclamation = (avis) => {
    setViewData(avis);
    setPatientData(avis.patient || null);
    setMissionData(avis.mission || null);
    setAmbulancierData(avis.mission?.ambulancier || null);
    setDoctorData(avis.mission?.doctor || null);
    setNurseData(avis.mission?.nurse || null);
    onReclamationOpen();
  };

  const handleClose = () => {
    onClose();
    setLoadingDetails(false);
    setMissionData(null);
    setPatientData(null);
    setAmbulancierData(null);
    setDoctorData(null);
    setNurseData(null);
  };

  // Ouvrir automatiquement le modal si ?id= est dans l'URL
  useEffect(() => {
    if (!tableData.length || loading) return;
    const params = new URLSearchParams(location.search);
    const idFromUrl = params.get('id');
    if (!idFromUrl) return;
    const avis = tableData.find(a => String(a.id) === String(idFromUrl));
    if (avis) {
      handleView(avis);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData, loading]);


  // Calculer les statistiques
  const stats = useMemo(() => {
    const total = tableData.length;
    const average = total > 0
      ? tableData.reduce((sum, avis) => sum + (parseFloat(avis.étoile) || 0), 0) / total
      : 0;

    const distribution = {
      5: tableData.filter(a => parseFloat(a.étoile) === 5).length,
      4: tableData.filter(a => parseFloat(a.étoile) === 4).length,
      3: tableData.filter(a => parseFloat(a.étoile) === 3).length,
      2: tableData.filter(a => parseFloat(a.étoile) === 2).length,
      1: tableData.filter(a => parseFloat(a.étoile) === 1).length,
    };

    const maxDistribution = Math.max(...Object.values(distribution));

    return { total, average, distribution, maxDistribution };
  }, [tableData]);


  // Filtrer et trier les données
  const processedData = useMemo(() => {
    let filtered = [...tableData];

    // Filtre par recherche
    if (searchTerm) {
      filtered = filtered.filter(avis => {
        const clientName = `${avis.patient?.nom || ''} ${avis.patient?.prenom || ''}`;
        return clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          avis.avi?.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }

    // Filtre par statut
    if (statusFilter !== 'all') {
      // Pour l'instant, on utilise un statut basique basé sur la visibilité
      // Vous pouvez adapter selon vos besoins
    }

    // Trier
    if (sortBy === 'latest') {
      filtered.sort((a, b) => new Date(b.créé_le) - new Date(a.créé_le));
    } else if (sortBy === 'oldest') {
      filtered.sort((a, b) => new Date(a.créé_le) - new Date(b.créé_le));
    } else if (sortBy === 'rating-high') {
      filtered.sort((a, b) => parseFloat(b.étoile) - parseFloat(a.étoile));
    } else if (sortBy === 'rating-low') {
      filtered.sort((a, b) => parseFloat(a.étoile) - parseFloat(b.étoile));
    }

    return filtered;
  }, [tableData, searchTerm, statusFilter, sortBy]);

  // Pagination
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return processedData.slice(startIndex, endIndex);
  }, [processedData, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(processedData.length / itemsPerPage);

  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  if (permissionsLoading) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (!hasPermission('avis_read')) {
    return (
      <Flex justify="center" align="center" h="100vh" direction="column">
        <Text fontSize="xl" fontWeight="bold" color="red.500">Accès refusé</Text>
        <Text>Vous n'avez pas la permission de consulter cette page.</Text>
      </Flex>
    );
  }

  return (
    <Box minH="100vh" bg={bgColor} p={6}>
      <Box maxW="9xl" mx="auto" mt={50}>
        <VStack spacing={6} align="stretch">
          {/* Breadcrumbs */}
          <Breadcrumb>
            <BreadcrumbItem>
              <BreadcrumbLink href="#" color="gray.600">Tableau de bord et analyses</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink color="gray.900" fontWeight="medium">Avis</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          {/* Header Section */}
          <Flex align="center" justify="space-between" mb={4}>
            <HStack spacing={3}>
              <Box
                w="40px"
                h="40px"
                bg="#459CE9"
                borderRadius="8px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon as={MdPerson} color="white" w="24px" h="24px" />
                <Icon as={MdChatBubble} color="white" w="16px" h="16px" ml="-8px" mt="8px" />
              </Box>
              <Heading size="xl" color="gray.900" fontWeight="bold">
                Avis
              </Heading>
            </HStack>

          </Flex>

          {/* Statistics Section */}
          {showStats && (
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={6}>
              {/* Nombre total d'avis */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px" h="100%">
                <VStack align="start" spacing={1.5} h="100%" justify="space-between">
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    Nombre total d'avis
                  </Text>
                  <HStack spacing={2}>
                    <Text fontSize="3xl" fontWeight="bold" color="gray.900">
                      {(stats.total / 1000).toFixed(1)}k
                    </Text>
                    <HStack spacing={1} color="#006133" bg="#0061342c" p={0.2} borderRadius="4px" border="1px solid #00613333">
                      <Icon as={MdArrowUpward} w="14px" h="14px" />
                      <Text fontSize="12px" fontWeight="small">+2.7%</Text>
                    </HStack>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Growth vs semaine précédente
                  </Text>
                </VStack>
              </Card>

              {/* Moyenne */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px" h="100%">
                <VStack align="start" spacing={1.5} h="100%" justify="space-between">
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    Moyenne
                  </Text>
                  <HStack spacing={1}>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Icon
                        key={star}
                        as={MdStar}
                        color={stats.average >= star ? 'yellow.400' : stats.average >= star - 0.5 ? 'yellow.200' : 'gray.300'}
                        w="18px"
                        h="18px"
                      />
                    ))}
                    <Text fontSize="lg" fontWeight="bold" color="gray.900" ml={2}>
                      {stats.average.toFixed(1)}
                    </Text>
                  </HStack>
                  <Text fontSize="xs" color="gray.500">
                    Moyenne actuelle basée sur tous les avis clients
                  </Text>
                </VStack>
              </Card>

              {/* Distribution des notes */}
              <Card bg={cardBg} borderRadius="12px" p={4} minH="140px" h="100%">
                <VStack align="start" spacing={2} h="100%" justify="space-between">
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    Distribution des notes
                  </Text>
                  <VStack align="stretch" spacing={1.5} flex={1} w="100%">
                    {[5, 4, 3, 2, 1].map((rating) => {
                      const count = stats.distribution[rating];
                      const percentage = stats.maxDistribution > 0
                        ? (count / stats.maxDistribution) * 100
                        : 0;
                      const colorSchemes = {
                        5: 'blue',
                        4: 'green',
                        3: 'orange',
                        2: 'red',
                        1: 'red'
                      };
                      return (
                        <Box key={rating} w="100%">
                          <HStack spacing={2}>
                            <Text fontSize="xs" color="gray.600" w="35px">
                              {rating} ★
                            </Text>
                            <Progress
                              value={percentage}
                              colorScheme={colorSchemes[rating]}
                              size="sm"
                              borderRadius="4px"
                              flex={1}
                              h="6px"
                            />
                            <Text fontSize="xs" color="gray.600" w="45px" textAlign="right">
                              {count}
                            </Text>
                          </HStack>
                        </Box>
                      );
                    })}
                  </VStack>
                </VStack>
              </Card>
            </SimpleGrid>
          )}

          {/* Liste des Avis */}
          <Card bg={cardBg} borderRadius="12px" p={6}>
            <VStack align="stretch" spacing={4}>
              <Text fontSize="lg" fontWeight="bold" color="gray.900">
                Liste des Avis
              </Text>

              {/* Filtres et recherche */}
              <HStack spacing={4} flexWrap="wrap">
                <InputGroup flex={1} minW="200px">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={MdSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Recherche d'un patient..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    bg="white"
                  />
                </InputGroup>
                <Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  w="150px"
                  bg="white"
                >
                  <option value="all">Statut: Tous</option>
                  <option value="visible">Visible</option>
                  <option value="hidden">Masqué</option>
                  <option value="pending">En attente</option>
                </Select>
                <Select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  w="150px"
                  bg="white"
                >
                  <option value="latest">Trier par: Dernière</option>
                  <option value="oldest">Plus ancienne</option>
                  <option value="rating-high">Note: Plus haute</option>
                  <option value="rating-low">Note: Plus basse</option>
                </Select>
                <HStack spacing={2}>
                  <IconButton
                    icon={<MdGridView />}
                    aria-label="Vue grille"
                    variant={viewMode === 'grid' ? 'solid' : 'outline'}
                    colorScheme={viewMode === 'grid' ? 'blue' : 'gray'}
                    size="sm"
                    onClick={() => setViewMode('grid')}
                  />
                  <IconButton
                    icon={<MdList />}
                    aria-label="Vue liste"
                    variant={viewMode === 'list' ? 'solid' : 'outline'}
                    colorScheme={viewMode === 'list' ? 'blue' : 'gray'}
                    size="sm"
                    onClick={() => setViewMode('list')}
                  />
                </HStack>
              </HStack>

              {/* Contenu - Tableau ou Grille */}
              {loading ? (
                <Center py={10}>
                  <Spinner size="xl" />
                </Center>
              ) : viewMode === 'grid' ? (
                <>
                  {/* Vue Grille */}
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                    {paginatedData.map((avis) => {
                      const patient = avis.patient;
                      const status = avis.statut || 'visible';
                      const statusTexts = {
                        visible: 'Visible',
                        hidden: 'Masqué',
                        pending: 'En attente'
                      };
                      const statusText = statusTexts[status] || statusTexts.visible;

                      return (
                        <Card key={avis.id} bg="white" borderRadius="12px" p={4} border="1px solid" borderColor="gray.200" _hover={{ shadow: 'md' }}>
                          <VStack align="stretch" spacing={3}>
                            {/* Header avec photo, nom, date et menu */}
                            <Flex justify="space-between" align="start">
                              <HStack spacing={3} flex={1}>
                                <VStack align="start" spacing={0} flex={1}>
                                  <Text fontWeight="semibold" fontSize="sm" color="gray.900" noOfLines={1}>
                                    {patient ? `${patient.nom || ''} ${patient.prenom || ''}` : 'Patient inconnu'}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    AV{String(avis.id).padStart(2, '0')} - {new Date(avis.créé_le).toLocaleDateString('fr-FR', {
                                      day: '2-digit',
                                      month: '2-digit',
                                      year: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </Text>
                                </VStack>
                              </HStack>
                              <Menu>
                                <MenuButton
                                  as={IconButton}
                                  icon={<MdMoreVert />}
                                  variant="ghost"
                                  size="sm"
                                  aria-label="Options"
                                />
                                <MenuList>
                                  <MenuItem icon={<MdVisibility />} onClick={() => handleView(avis)}>
                                    Voir détails
                                  </MenuItem>
                                  {hasPermission('reclamations_create') && (
                                    <MenuItem icon={<MdEdit />} onClick={() => handleReclamation(avis)}>
                                      Traiter réclamation
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Flex>

                            {/* Statut */}
                            <StatusBadge status={status} />

                            {/* Commentaire */}
                            <Text fontSize="sm" color="gray.700" noOfLines={3}>
                              {avis.avi || 'Aucun commentaire'}
                            </Text>

                            {/* Note avec étoiles */}
                            <HStack spacing={2} align="center">
                              <Text fontSize="xs" color="gray.600" fontWeight="medium">
                                Avis
                              </Text>
                              <RatingBadge rating={avis.étoile} />
                            </HStack>
                          </VStack>
                        </Card>
                      );
                    })}
                  </SimpleGrid>
                </>
              ) : (
                <>
                  {/* Vue Liste - Tableau */}
                  <TableContainer border="1px solid" borderColor="gray.200" borderRadius="12px" overflowX="auto">
                    <Table variant="simple" minW="1200px" sx={{ 'th, td': { borderRight: '1px solid', borderBottom: '1px solid', borderColor: 'gray.200', whiteSpace: 'nowrap' }, 'th:last-child, td:last-child': { borderRight: 'none' }, 'tr:last-child td': { borderBottom: 'none' } }}>
                      <Thead>
                        <Tr bg="gray.50">
                          <Th w="50px"><Checkbox /></Th>
                          <Th w="80px">ID</Th>
                          <Th minW="200px">Nom du Patient</Th>
                          <Th minW="400px" style={{ whiteSpace: 'normal' }}>Commentaire</Th>
                          <Th w="180px">Avis</Th>
                          <Th w="180px">Date d'ajout</Th>
                          <Th w="150px">Statut</Th>
                          <Th w="80px">Actions</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {paginatedData.map((avis) => {
                          const patient = avis.patient;
                          const status = avis.statut || 'visible';

                          return (
                            <Tr key={avis.id} _hover={{ bg: 'gray.50' }}>
                              <Td><Checkbox /></Td>
                              <Td fontWeight="medium">AV{String(avis.id).padStart(2, '0')}</Td>
                              <Td>
                                <HStack spacing={2}>
                                  {patient?.logo ? (
                                    <ImageWithFallback
                                      src={patient.logo}
                                      alt={patient.nom}
                                      style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <Avatar size="sm" style={{ borderRadius: '0%' }} name={`${patient?.nom || ''} ${patient?.prenom || ''}`} />
                                  )}
                                  <Text>{`${patient?.nom || ''} ${patient?.prenom || ''}` || 'Patient inconnu'}</Text>
                                </HStack>
                              </Td>
                              <Td style={{ whiteSpace: 'normal' }}>
                                <Text noOfLines={2}>
                                  {avis.avi || 'Aucun commentaire'}
                                </Text>
                              </Td>
                              <Td>
                                <RatingBadge rating={avis.étoile} />
                              </Td>
                              <Td>
                                {new Date(avis.créé_le).toLocaleDateString('fr-FR', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </Td>
                              <Td>
                                <StatusBadge status={status} />
                              </Td>
                              <Td>
                                <Menu>
                                  <MenuButton
                                    as={IconButton}
                                    icon={<MdMoreVert />}
                                    variant="ghost"
                                    size="sm"
                                  />
                                  <MenuList>
                                    <MenuItem icon={<MdVisibility />} onClick={() => handleView(avis)}>
                                      Voir détails
                                    </MenuItem>
                                    {hasPermission('reclamations_create') && (
                                      <MenuItem icon={<MdEdit />} onClick={() => handleReclamation(avis)}>
                                        Traiter réclamation
                                      </MenuItem>
                                    )}
                                  </MenuList>
                                </Menu>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </>
              )}

              {/* Pagination - Affichée pour les deux vues */}
              {!loading && paginatedData.length > 0 && (
                <Flex justify="space-between" align="center" pt={4}>
                  <HStack spacing={2}>
                    <Text fontSize="sm" color="gray.600">Afficher</Text>
                    <Select
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      w="100px"
                      size="sm"
                      bg="white"
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Select>
                    <Text fontSize="sm" color="gray.600">par page</Text>
                  </HStack>
                  <Text fontSize="sm" color="gray.600">
                    {((currentPage - 1) * itemsPerPage) + 1} à {Math.min(currentPage * itemsPerPage, processedData.length)} sur {processedData.length}
                  </Text>
                  <HStack spacing={2}>
                    <IconButton
                      icon={<MdChevronLeft />}
                      aria-label="Page précédente"
                      onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                      isDisabled={currentPage === 1}
                      size="sm"
                    />
                    {[...Array(Math.min(5, totalPages))].map((_, i) => {
                      const pageNum = i + 1;
                      return (
                        <Button
                          key={pageNum}
                          size="sm"
                          onClick={() => setCurrentPage(pageNum)}
                          colorScheme={currentPage === pageNum ? 'blue' : 'gray'}
                          variant={currentPage === pageNum ? 'solid' : 'outline'}
                        >
                          {pageNum}
                        </Button>
                      );
                    })}
                    <IconButton
                      icon={<MdChevronRight />}
                      aria-label="Page suivante"
                      onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                      isDisabled={currentPage === totalPages}
                      size="sm"
                    />
                  </HStack>
                </Flex>
              )}
            </VStack>
          </Card>
        </VStack>
      </Box>
      {/* Modal de détail de l'avis */}
      {/* Modal de détail de l'avis */}
      <AvisDetailModal
        isOpen={isOpen}
        onClose={handleClose}
        viewData={viewData}
        loadingDetails={loadingDetails}
        missionData={missionData}
        patientData={patientData}
        ambulancierData={ambulancierData}
        doctorData={doctorData}
        nurseData={nurseData}
      />

      <TraitementReclamationModal
        isOpen={isReclamationOpen}
        onClose={onReclamationClose}
        viewData={viewData}
        loadingDetails={loadingDetails}
        missionData={missionData}
        patientData={patientData}
        onCreated={() => {}}
      />
    </Box>
  );
}
